import { createFeatureSelector, createSelector } from '@ngrx/store';

import { DATA_ACCESS_SCREENSIZE_FEATURE_KEY, State } from './data-access-screensize.reducer';

export const getDataAccessScreensizeState = createFeatureSelector<State>(DATA_ACCESS_SCREENSIZE_FEATURE_KEY);

export const getSize = createSelector(getDataAccessScreensizeState, (state: State) => state.size);

export const getCardSliderConfig = createSelector(
  getDataAccessScreensizeState,
  (state: State) => state.sliderConfig.card
);

export const getVideoSliderConfig = createSelector(
  getDataAccessScreensizeState,
  (state: State) => state.sliderConfig.video
);

export const getImageSliderConfig = createSelector(
  getDataAccessScreensizeState,
  (state: State) => state.sliderConfig.image
);
